import React, { Component } from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import StyledActionButton from 'components/layout/StyledActionButton';

const PopupStyle = {
  borderRadius: 5,
  opacity: 0.7,
  padding: '7px'
};

interface Props {
  hoverMessage: string,
  onConfirm: () => void
}

interface State {

}

class CancelActionButton extends Component<Props, State> {

  render(): React.ReactNode {
    const {hoverMessage, onConfirm} = this.props;

    return (
        <StyledActionButton
            type='button'
            icon
            onClick={onConfirm}
        >
          <Popup
              trigger={<Icon name="delete"/>}
              content={hoverMessage}
              size='small'
              position='top center'
              style={PopupStyle}
              inverted
          />
        </StyledActionButton>
    )
  }

}

export default CancelActionButton;
